// extracted by mini-css-extract-plugin
export default {"barFooter":"FooterBar_barFooter__6r42e","menuFooter":"FooterBar_menuFooter__f+RxO"};